import { PitchPlayerCountResponse } from '@intelligent-play-v2/domain';
import { FilteredStatisticsParams } from '~/types';
import { queryBuilder } from '~/api';

export const getPlayerCount = async ({
  pitchIds,
  timePeriod,
  from,
  to,
  timezone,
  dailyStartTime,
  dailyEndTime,
  includedDays,
}: FilteredStatisticsParams): Promise<PitchPlayerCountResponse[]> => {
  const { data } = await queryBuilder('GET', 'stats/playerCount', {
    timePeriod,
    from,
    to,
    pitchIds: pitchIds.join(','),
    timezone,
    dailyStartTime,
    dailyEndTime,
    includedDays: includedDays?.join(','),
  });
  return data;
};
